// Basic JavaScript for progressive enhancement
import { AccessibleNavigation } from "./navigation.js";
import { ScrollMenu } from "./scrollMenu.js";
import { CopyEmail } from "./copyEmail.js";

const FBS = {
  init() {
    this.addLoadedClass();
    this.navigation = this.initNavigation();
    this.initThemeToggle();
    this.scrollMenu = new ScrollMenu();
    new CopyEmail();
  },

  addLoadedClass() {
    document.documentElement.classList.add('js-loaded');
  },

  initThemeToggle() {
    const saved = localStorage.getItem('theme') ||
      (matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
    document.documentElement.setAttribute('data-theme', saved);

    const toggle = document.getElementById('theme-toggle');
    if (toggle) {
      // Set initial state
      this.updateThemeToggleState(toggle, saved);

      toggle.onclick = () => {
        const current = document.documentElement.getAttribute('data-theme');
        const next = current === 'dark' ? 'light' : 'dark';

        document.documentElement.setAttribute('data-theme', next);
        localStorage.setItem('theme', next);

        // Update button state and provide feedback
        this.updateThemeToggleState(toggle, next);
        this.announceThemeChange(next);

        // Close mobile menu when theme toggle is clicked
        if (this.navigation) {
          this.navigation.closeMobileMenu();
        }
      };
    }
  },

  updateThemeToggleState(toggle, theme) {
    const isDark = theme === 'dark';
    const isPressed = isDark;

    toggle.setAttribute('aria-pressed', isPressed);
    toggle.setAttribute('aria-label',
      isDark ? 'Cambia tema da scuro a chiaro' : 'Cambia tema da chiaro a scuro'
    );
    toggle.setAttribute('title',
      `Attualmente: tema ${isDark ? 'scuro' : 'chiaro'}`
    );
  },

  announceThemeChange(newTheme) {
    // Create or update live region for theme announcements
    let announcement = document.getElementById('theme-announcement');
    if (!announcement) {
      announcement = document.createElement('div');
      announcement.id = 'theme-announcement';
      announcement.setAttribute('aria-live', 'polite');
      announcement.setAttribute('aria-atomic', 'true');
      announcement.className = 'visually-hidden';
      document.body.appendChild(announcement);
    }

    const message = `Tema cambiato in ${newTheme === 'dark' ? 'scuro' : 'chiaro'}`;
    announcement.textContent = message;

    // Clear the message after announcement
    setTimeout(() => {
      announcement.textContent = '';
    }, 1000);
  },

  initNavigation() {
    return new AccessibleNavigation();
  }
};

// Initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => FBS.init());
} else {
  FBS.init();
}
